import React, {Component} from "react";
import SimpleReactValidator from "simple-react-validator";

/* Import Components */
import CheckBox from "./CheckBox";
import Input from "./Input";
import TextArea from "./TextArea";
import Select from "./Select";
import Button from "./Button";
import EmailInput from "./EmailInput";
import RadioButton from "./RadioButton";
import TelephoneInput from "./TelephoneInput";
import Confirmation from "./Confirmation";
import ResearchDisclaimer from "./ResearchDisclaimer";

import FetchHelper from "./helpers/FetchHelper";

class FormContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initialState: true,
            loading: false,
            submitted: false,
            newUser: {system: "SCHOOLS"},
            genderOptions: ["Male", "Female", "Non-binary", "Prefer not to say"],
            skillOptions: [
                "Cognition & Learning",
                "Behavioural, Emotional & Social Development",
                "Communication & Interaction",
                "Sensory &/or Physical"
            ],
            schoolParentOptions: [],
            schoolOptions: [],
            schoolServiceOptions: [
                "Primary",
                "Secondary",
                "College",
                "Community",
                "Other"
            ],
            schoolYearOptions: props.schoolYearOptions || [],

            radioOptions: ["Yes", "No"],
            yesMaybeNo: ["Yes", "Maybe", "No"],
            yesMaybeNoOther: ["Yes", "No", "Maybe", "Other"],
            pupilConsent: ["Yes"]
        };

        const validateNumber = (phone_number) => {
            if (!phone_number || phone_number?.length === 0) {
                return {
                    valid: true,
                    message: "phone number not required"
                }
            } else {
                if (phone_number?.startsWith('07') || phone_number?.startsWith('+44')) {
                    let numberLength = phone_number.length || 0
                    if (phone_number?.startsWith('0')) {
                        if (numberLength !== 11) {
                            return {
                                valid: false,
                                message: `UK phone number starting with (0) must be 11 characters, currently ${numberLength} chars.`
                            }
                        }
                    }
                    if (phone_number?.startsWith('+44')) {
                        if (numberLength !== 13) {
                            return {
                                valid: false,
                                message: `UK phone number starting with (+44) must be 13 characters, currently ${numberLength} chars`
                            }
                        }
                    }
                    if (!phone_number?.match(/^[+0-9]*$/)) {
                        return {
                            valid: false,
                            message: "A phone number can only have numbers or +"
                        }
                    }
                } else {
                    return {
                        valid: false,
                        message: `UK phone number must start with either (+44) or (07)`
                    }
                }
            }
            return {
                valid: true,
            }
        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: "en",
            className: "text-danger",
            validators: {
                custom_phone_number: {
                    message: ':replaced',
                    rule: (val, params, validator) => {
                        return validateNumber(val).valid
                    },
                    messageReplace: (message, params) => {
                        return validateNumber(params[0]).message
                    },  // optional
                }
            }
        });
    }

    /* This lifecycle hook gets executed when the component mounts */
    componentDidMount() {
        this.fetchSchoolParents();
    }

    renderErrorPage = () => {
        window.location.assign("/500.html");
    };

    handleDateChange = (selectedDate, modifiers, dayPickerInput) => {
        const {name} = dayPickerInput.props;
        this.setState(prevState => ({
            newUser: {
                ...prevState.newUser,
                [name]: selectedDate
            }
        }));
    };

    handleRadioChange = e => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState(prevState => ({
            newUser: {
                ...prevState.newUser,
                [name]: value
            }
        }));
    };

    handleInputChange = e => {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            newUser: {
                ...prevState.newUser,
                [name]: value
            }
        }));
    };

    handleCheckBox = e => {
        const {name, value} = e.target;
        const {newUser} = this.state;
        let values = newUser[name] || [];
        if (values.indexOf(value) > -1) {
            values = values.filter(s => s !== value);
        } else {
            values.push(value);
        }

        this.setState(prevState => ({
            newUser: {...prevState.newUser, [name]: values}
        }));
    };

    handleFormSubmit = e => {
        e.preventDefault();

        const {csrfToken, parentDomain} = this.props;
        let userData = this.state.newUser;

        this.setState({initialState: false});

        FetchHelper.fetchWithPost({
            context: this,
            csrfToken,
            parentDomain,
            type: "school",
            body: userData
        });
    };

    handleSchoolParentChange = e => {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(
            prevState => ({
                newUser: {
                    ...prevState.newUser,
                    [name]: value
                }
            }),
            this.fetchSchools
        );
    };

    fetchSchoolParents = () => {
        this.setState({schoolsLoading: true});

        fetch("/v1/organisations/schools", {
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": this.props.csrfToken
            }
        })
            .then(response => {
                return response.json().then(data => {
                    return {
                        data: data,
                        status: response.status
                    };
                });
            })
            .then(response => {
                switch (response.status) {
                    case 200:
                        this.setState({
                            allSchools: response.data,
                            schoolParentOptions: response.data.filter(
                                e => e.parent_id === null
                            ),
                            schoolsLoading: false
                        });
                        break;
                    default:
                        console.log("Unexpected status: " + response.status);
                        this.renderErrorPage();
                }
            })
            .catch(({exception}) => {
                this.setState({loading: false});
                console.log(exception);
                this.renderErrorPage();
            });
    };

    fetchSchools = () => {
        const {allSchools} = this.state;

        this.setState({
            schoolOptions: (allSchools || []).filter(
                e => e.parent_id === parseInt(this.state.newUser.schoolParent)
            )
        });
    };

    renderSubmitButton = () => {
        const {initialState, loading} = this.state;
        const valid = initialState || this.validator.allValid();
        return (
            <>
                {!valid && (
                    <div className="alert alert-danger">
                        There are unresolved form errors, please correct the form before
                        resubmitting.
                    </div>
                )}
                <Button
                    type="submit"
                    className="btn-primary"
                    disabled={!valid || loading}
                >
                    Submit
                </Button>
            </>
        );
    };

    render() {
        const {
            email,
            gender,
            address1,
            address2,
            address3,
            address4,
            schoolConfirmation,
            dateOfBirth,
            name,
            postcode,
            pupilMobileNo,
            physicalDisabilities,
            physicalDisabilitiesDetail,
            referralReason,
            schoolService,
            personSupported,
            personSupportedDetail,
            schoolYear,
            schoolParent,
            school,
        } = this.state.newUser;

        const {
            schoolParentOptions,
            schoolOptions,
            schoolsLoading,
            schoolServiceOptions,
            schoolsServiceLoading,
            schoolYearOptions,
            schoolYearLoading,
            genderOptions,
            submitted
        } = this.state;

        return (
            <div className="container">
                <h1>
                    D-EXY
                    <small>Referrals for counselling and psychological support</small>
                </h1>
                <div className="row justify-content-start">
                    {submitted ? (
                        <Confirmation
                            referralType="D-EXY"
                            returnCallback={() => {
                                this.setState({
                                    submitted: false,
                                    newUser: {system: "SCHOOLS"},
                                    initialState: true
                                });
                            }}
                        />
                    ) : (
                        <form className="col-8" onSubmit={this.handleFormSubmit} noValidate>
                            <div className="alert alert-secondary">
                                <p>
                                    Fields marked with <span className="required-field">*</span>{" "}
                                    are mandatory.
                                </p>
                            </div>
                            <div className="form-group">
                                <EmailInput
                                    label={"Your Email address"}
                                    name="email"
                                    id="email"
                                    value={email}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message("email", email, "required|email")}
                            </div>
                            <h2>Details for the person being referred</h2>
                            <div className="form-group">
                                <Input
                                    inputtype={"text"}
                                    label="Your full name"
                                    name="name"
                                    value={name}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "full name",
                                    name,
                                    "required|alpha_space"
                                )}
                            </div>

                            <div className="form-group">
                                <Input
                                    name="dateOfBirth"
                                    label="Date of Birth (DD/MM/YYYY)"
                                    value={dateOfBirth}
                                    required={true}
                                    type="date"
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "date of birth",
                                    dateOfBirth,
                                    "required"
                                )}
                            </div>

                            <div className="form-group">
                                <RadioButton
                                    label="Gender"
                                    name="gender"
                                    options={genderOptions}
                                    value={gender}
                                    onChange={this.handleInputChange}
                                    required={true}
                                />{" "}
                                {this.validator.message("gender", gender, "required")}
                            </div>
                            <h2>Address</h2>
                            <div className="form-group">
                                <Input
                                    name="address1"
                                    label="Line 1"
                                    value={address1}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message("address line 1", address1, "required")}
                            </div>
                            <div className="form-group">
                                <Input
                                    name="address2"
                                    label="Line 2"
                                    value={address2}
                                    onChange={this.handleInputChange}
                                />{" "}
                            </div>
                            <div className="form-group">
                                <Input
                                    name="address3"
                                    label="Line 3"
                                    value={address3}
                                    onChange={this.handleInputChange}
                                />{" "}
                            </div>
                            <div className="form-group">
                                <Input
                                    name="address4"
                                    label="Line 4"
                                    value={address4}
                                    onChange={this.handleInputChange}
                                />{" "}
                            </div>
                            <div className="form-group">
                                <Input
                                    name="postcode"
                                    label="Postcode"
                                    value={postcode}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "postcode",
                                    postcode,
                                    "required|alpha_num_space"
                                )}
                            </div>
                            <div className="form-group">
                                <TelephoneInput
                                    name="pupilMobileNo"
                                    label={"Your contact number"}
                                    value={pupilMobileNo}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "contact number",
                                    pupilMobileNo,
                                    `required|custom_phone_number:${pupilMobileNo}`,
                                )}
                            </div>
                            <div className="form-group">
                                <Input
                                    name="referralReason"
                                    label="Reason for referral"
                                    value={referralReason}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />
                                {this.validator.message(
                                    "reason for referral",
                                    referralReason,
                                    "required"
                                )}
                            </div>
                            <div className="form-group">
                                <RadioButton
                                    label={
                                        "Do you have any physical disabilities?"
                                    }
                                    name={"physicalDisabilities"}
                                    options={this.state.yesMaybeNo}
                                    value={physicalDisabilities}
                                    required
                                    onChange={this.handleRadioChange}
                                />{" "}
                                {this.validator.message(
                                    "physical disabilities",
                                    physicalDisabilities,
                                    "required"
                                )}
                            </div>
                            <div className="form-group">
                                {physicalDisabilities && physicalDisabilities != "No" && (
                                    <TextArea
                                        name="physicalDisabilitiesDetail"
                                        label="Please give details of the physical disabilities"
                                        value={physicalDisabilitiesDetail}
                                        required={true}
                                        maxLength={2000}
                                        onChange={this.handleInputChange}
                                    />
                                )}
                            </div>

                            <h2>Additional details</h2>
                            <div className="alert alert-secondary">
                                Please answer any questions that are applicable.
                            </div>

                            <div className="form-group">
                                <Select
                                    label="School or other"
                                    name="schoolService"
                                    options={schoolServiceOptions}
                                    value={schoolService}
                                    placeholder={"Please Select"}
                                    handleChange={this.handleInputChange}
                                    loading={schoolsServiceLoading}
                                    required
                                />{" "}
                                {this.validator.message(
                                    "school or other",
                                    schoolService,
                                    "required"
                                )}
                            </div>

                            <div className="form-group">
                                <Select
                                    label="School service"
                                    name="schoolParent"
                                    options={schoolParentOptions}
                                    value={schoolParent}
                                    placeholder={"Please Select"}
                                    handleChange={this.handleSchoolParentChange}
                                    loading={schoolsLoading}
                                    required
                                />{" "}
                                {this.validator.message(
                                    "school service",
                                    schoolParent,
                                    "required"
                                )}
                            </div>

                            <div className="form-group">
                                <Select
                                    label="School"
                                    name="school"
                                    options={schoolOptions}
                                    value={school}
                                    placeholder={"Please Select"}
                                    handleChange={this.handleInputChange}
                                    required
                                />{" "}
                                {this.validator.message("school", school, "required")}
                            </div>

                            <div className="form-group">
                                <Select
                                    label="School year"
                                    name="schoolYear"
                                    options={schoolYearOptions}
                                    value={schoolYear}
                                    placeholder={"Please Select"}
                                    handleChange={this.handleInputChange}
                                    loading={schoolYearLoading}
                                    required
                                />{" "}
                                {this.validator.message("school year", schoolYear, "required")}
                            </div>

                            <div className="form-group">
                                <RadioButton
                                    name={"personSupported"}
                                    label={
                                        "Are you being supported by any other service?"
                                    }
                                    options={this.state.yesMaybeNo}
                                    value={personSupported}
                                    onChange={this.handleRadioChange}
                                />
                            </div>
                            <div className="form-group">
                                {personSupported && personSupported != "No" && (
                                    <TextArea
                                        name="personSupportedDetail"
                                        label="Details of any services"
                                        value={personSupportedDetail}
                                        required={true}
                                        maxLength={2000}
                                        onChange={this.handleInputChange}
                                    />
                                )}
                            </div>
                            <div className="form-group">
                                <CheckBox
                                    label="
                    This statement is for those who are accessing our services for themselves
                    or on behalf of another person (i.e. making a referral) If you are accessing
                    the services for yourself, please read this statement because it sets out what
                    you are consenting to. If you are referring someone to receive confidential support
                    please read and confirm. To process this referral and put in place psychological wellbeing
                    support, the organisation requires the information which is to be entered into the referral form.
                    This is personal information covered under the GDPR regulations and therefore it is a requirement
                    that the person who is being referred has consented to the personal information being shared with this
                    organisation. The data is confidential and not shared with others, but we retain the right to use this
                    information to contact others if we believe the person receiving our support (or others) is in danger or
                    at risk of abuse. As far as possible we will seek consent before taking this action, but the safety of
                    those we support is our priority.
                "
                                    helpText="If the support is for you then it is necessary to confirm that you
                    understand this statement. If the referral is being made on behalf of another, then the person making
                    the referral must confirm that the consent of the person has been sought and received."
                                    name="schoolConfirmation"
                                    options={["I agree"]}
                                    selectedOptions={schoolConfirmation}
                                    onChange={this.handleCheckBox}
                                    required={true}
                                />
                                {this.validator.message(
                                    "agreement",
                                    schoolConfirmation,
                                    "required"
                                )}
                            </div>

                            {this.renderSubmitButton()}
                        </form>
                    )}
                            <ResearchDisclaimer />
                </div>
            </div>
        );
    }
}

export default FormContainer;
